"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));
var _alloyReactRadioButton = require("@adsk/alloy-react-radio-button");
var _i18n = require("../../../i18n");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SaveOptions = _ref => {
  let {
    className,
    disabled,
    saveAsNewFile,
    isQrp,
    onChange
  } = _ref;
  const {
    T
  } = (0, _i18n.useTranslation)();
  return /*#__PURE__*/_react.default.createElement(StyledContainer, {
    className: className,
    $isQrp: isQrp
  }, /*#__PURE__*/_react.default.createElement(StyledTitle, null, T.translate('saveOptions.title')), /*#__PURE__*/_react.default.createElement(StyledRadioGroup, {
    name: "saveOptions",
    value: saveAsNewFile,
    onChange: value => onChange({
      saveAsNewFile: value
    }),
    $isQrp: isQrp
  }, /*#__PURE__*/_react.default.createElement(StyledRadioGroupItem, null, /*#__PURE__*/_react.default.createElement(StyledRadioButton, {
    value: false,
    disabled: disabled
  }), /*#__PURE__*/_react.default.createElement(StyledRadioButtonTitle, {
    $disabled: disabled
  }, T.translate('saveOptions.newVersion'))), /*#__PURE__*/_react.default.createElement(StyledRadioGroupItem, null, /*#__PURE__*/_react.default.createElement(StyledRadioButton, {
    value: true,
    disabled: disabled
  }), /*#__PURE__*/_react.default.createElement(StyledRadioButtonTitle, {
    $disabled: disabled
  }, T.translate('saveOptions.newFile')))));
};
const StyledContainer = _styledComponents.default.div`
  ${_ref2 => {
  let {
    $isQrp
  } = _ref2;
  return `
    ${$isQrp && 'padding-left: 16px;'}
  `;
}}
`;
const StyledTitle = _styledComponents.default.div`
  color: #3c3c3c;
  padding-bottom: 8px;
  white-space: nowrap;
  ${{
  ..._alloyReactTheme.default.typography.labelSmall
}}
`;
const StyledRadioGroup = (0, _styledComponents.default)(_alloyReactRadioButton.RadioGroup)`
  ${_ref3 => {
  let {
    $isQrp
  } = _ref3;
  return `
    flex-direction: ${$isQrp ? 'column' : 'row'};
    gap: ${$isQrp ? '8px' : '37px'};
  `;
}}
`;
const StyledRadioGroupItem = _styledComponents.default.div`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  ${{
  ..._alloyReactTheme.default.typography.labelMedium
}}
`;
const StyledRadioButtonTitle = _styledComponents.default.span`
  flex-shrink: 0;
  ${_ref4 => {
  let {
    $disabled
  } = _ref4;
  return `
    color: ${$disabled ? '#999999' : '#3c3c3c'};
  `;
}}
`;
const StyledRadioButton = (0, _styledComponents.default)(_alloyReactRadioButton.RadioButton)`
  box-sizing: border-box;
  flex-shrink: 0;
`;
SaveOptions.propTypes = {
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool.isRequired,
  saveAsNewFile: _propTypes.default.bool.isRequired,
  isQrp: _propTypes.default.bool.isRequired,
  onChange: _propTypes.default.func.isRequired
};
var _default = exports.default = SaveOptions;